<template>
  <svg
    id="_002-chef"
    data-name="002-chef"
    xmlns="http://www.w3.org/2000/svg"
    width="33.185"
    height="33.185"
    viewBox="0 0 33.185 33.185"
  >
    <g id="Сгруппировать_3422" data-name="Сгруппировать 3422">
      <g id="Сгруппировать_3421" data-name="Сгруппировать 3421">
        <path
          id="Контур_3583"
          data-name="Контур 3583"
          d="M87.418,384H64.8a.755.755,0,0,0-.754.753l0,2.2a3.078,3.078,0,0,0,3.077,3.081H85.1a3.081,3.081,0,0,0,3.077-3.077v-2.2A.754.754,0,0,0,87.418,384Z"
          transform="translate(-59.513 -356.849)"
          fill="#fff"
        />
        <path
          id="Контур_3584"
          data-name="Контур 3584"
          d="M24.888,3.017a7.818,7.818,0,0,0-1.438.14A9.043,9.043,0,0,0,7.542,9.05a.754.754,0,1,1-1.508,0,10.417,10.417,0,0,1,1.117-4.7.754.754,0,0,0-.857-1.069,8.276,8.276,0,0,0-1.75,15.42l-.008,6.182a.753.753,0,0,0,.754.755H27.905a.754.754,0,0,0,.754-.754V18.7A8.291,8.291,0,0,0,24.888,3.017ZM11.037,20.947a.756.756,0,0,1-1.062-.1c-.249-.3-2.433-3.023-2.433-5a.754.754,0,1,1,1.508,0c0,1.092,1.283,3.061,2.092,4.046A.756.756,0,0,1,11.037,20.947Zm6.309-.583a.754.754,0,1,1-1.508,0V15.838a.754.754,0,1,1,1.508,0v4.525Zm5.863.479a.754.754,0,0,1-1.167-.957c.809-.988,2.092-2.959,2.092-4.047a.754.754,0,1,1,1.508,0C25.643,17.819,23.458,20.538,23.209,20.842Z"
          transform="translate(0 0)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'IconKitchen',
  }
</script>
